module.exports = __webpack_public_path__ + "img/total.9e0d479e.png";